var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrUnlimitedCreativity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 596,
    height: 287,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#111111",
    d: "m64.1338,55.04l19.44,3.84c-3.72,20.16 -19.92,31.92 -40.56,31.92c-23.88,0 -42.72004,-18.36 -42.72004,-42c0,-23.52 18.84004,-42 42.72004,-42c19.8,0 36.6,11.76 40.44,30.84l-19.44,4.56c-2.52,-11.64 -10.68,-17.28 -21,-17.28c-12.72,0 -22.92,10.2 -22.92,23.88c0,13.68 10.2,24 22.92,24c10.2,0 18.36,-5.76 21.12,-17.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#111111",
    d: "m134.654,27.92c1.68,0 2.88,0.12 4.32,0.48l-0.84,19.2l-3.48,0c-13.44,0 -20.76,6.96 -20.76,22.56l0,18.84l-19.1996,0l0,-60.24l19.1996,0l0,11.52c4.32,-7.2 10.92,-12.36 20.76,-12.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#111111",
    d: "m183.566,20.96l-17.04,0l8.52,-18.24l22.8,0l-14.28,18.24zm22.2,37.92l0,4.92l-44.16,0c1.56,7.2 6.48,11.64 12.96,11.64c4.44,0 9.6,-1.08 12.84,-6.96l17.04,3.48c-5.16,12.72 -16.08,18.84 -29.88,18.84c-17.4,0 -31.8,-12.84 -31.8,-31.92c0,-18.96 14.4,-31.92 31.92,-31.92c17.04,0 30.72,12.24 31.08,31.92zm-31.08,-16.32c-5.4,0 -10.92,3.36 -12.72,9.48l24.84,0c-1.8,-6.48 -6.6,-9.48 -12.12,-9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#111111",
    d: "m279.109,28.76l0,60.24l-19.2,0l0,-4.8c-4.68,4.2 -10.92,6.6 -18.72,6.6c-15.96,0 -29.4,-12.84 -29.4,-31.92c0,-18.96 13.44,-31.92 29.4,-31.92c7.8,0 14.04,2.4 18.72,6.6l0,-4.8l19.2,0zm-33.96,45.72c7.8,0 14.76,-6.24 14.76,-15.6c0,-9.24 -6.96,-15.6 -14.76,-15.6c-8.4,0 -14.52,6.36 -14.52,15.6c0,9.36 6.12,15.6 14.52,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#111111",
    d: "m333.176,71.24l4.44,15.12c-4.68,2.52 -9.6,4.44 -16.44,4.44c-15,0 -24,-8.16 -24,-24l0,-22.8l-10.92,0l0,-15.24l10.92,0l0,-17.76l19.2,0l0,17.76l17.76,0l0,15.24l-17.76,0l0,20.88c0,6.24 3,8.76 8.04,8.76c2.64,0 6.24,-0.96 8.76,-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#111111",
    d: "m365.05,89l-19.2,0l0,-60.24l19.2,0l0,60.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#111111",
    d: "m443.289,28.64l-24.96,60.36l-19.56,0l-24.96,-60.36l20.28,0l14.52,37.2l14.4,-37.2l20.28,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#111111",
    d: "m471.222,89l-19.2,0l0,-60.24l19.2,0l0,60.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#111111",
    d: "m526.301,71.24l4.44,15.12c-4.68,2.52 -9.6,4.44 -16.44,4.44c-15,0 -24,-8.16 -24,-24l0,-22.8l-10.92,0l0,-15.24l10.92,0l0,-17.76l19.2,0l0,17.76l17.76,0l0,15.24l-17.76,0l0,20.88c0,6.24 3,8.76 8.04,8.76c2.64,0 6.24,-0.96 8.76,-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#111111",
    d: "m573.683,20.96l-17.04,0l8.52,-18.24l22.8,0l-14.28,18.24zm22.2,37.92l0,4.92l-44.16,0c1.56,7.2 6.48,11.64 12.96,11.64c4.44,0 9.6,-1.08 12.84,-6.96l17.04,3.48c-5.16,12.72 -16.08,18.84 -29.88,18.84c-17.4,0 -31.8,-12.84 -31.8,-31.92c0,-18.96 14.4,-31.92 31.92,-31.92c17.04,0 30.72,12.24 31.08,31.92zm-31.08,-16.32c-5.4,0 -10.92,3.36 -12.72,9.48l24.84,0c-1.8,-6.48 -6.6,-9.48 -12.12,-9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#111111",
    d: "m75.9219,178.88l0,4.92l-44.16,0c1.56,7.2 6.48,11.64 12.96,11.64c4.44,0 9.6,-1.08 12.84,-6.96l17.04,3.48c-5.16,12.72 -16.08,18.84 -29.88,18.84c-17.4,0 -31.8,-12.84 -31.8,-31.92c0,-18.96 14.4,-31.92 31.92,-31.92c17.04,0 30.72,12.24 31.08,31.92zm-31.08,-16.32c-5.4,0 -10.92,3.36 -12.72,9.48l24.84,0c-1.8,-6.48 -6.6,-9.48 -12.12,-9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#111111",
    d: "m123.585,146.96c14.04,0 23.4,9.96 23.4,25.08l0,36.96l-19.08,0l0,-32.88c0,-7.08 -4.2,-11.88 -10.32,-11.88c-7.56,0 -12.48,5.16 -12.48,16.8l0,27.96l-19.1997,0l0,-60.24l19.1997,0l0,5.76c4.56,-4.8 10.92,-7.56 18.48,-7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#111111",
    d: "m207.776,209l-19.8,0l0,-80.4l19.8,0l0,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#111111",
    d: "m240.926,209l-19.2,0l0,-86.4l19.2,0l0,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#111111",
    d: "m274.09,209l-19.2,0l0,-86.4l19.2,0l0,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#111111",
    d: "m308.214,209l-19.2,0l0,-60.24l19.2,0l0,60.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#111111",
    d: "m401.093,146.96c12.84,0 23.04,9.72 23.04,24.36l0,37.68l-19.08,0l0,-33.6c0,-6.84 -4.44,-11.16 -10.08,-11.16c-7.08,0 -11.76,5.16 -11.76,15.24l0,29.52l-19.2,0l0,-33.6c0,-6.84 -4.44,-11.16 -10.2,-11.16c-6.96,0 -11.52,5.16 -11.52,15.24l0,29.52l-19.2,0l0,-60.24l19.2,0l0,5.52c4.08,-4.56 9.96,-7.32 17.76,-7.32c8.4,0 15.6,3.6 19.68,10.2c4.8,-6.24 12,-10.2 21.36,-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#111111",
    d: "m457.393,209l-19.2,0l0,-60.24l19.2,0l0,60.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#111111",
    d: "m512.472,191.24l4.44,15.12c-4.68,2.52 -9.6,4.44 -16.439,4.44c-15,0 -24,-8.16 -24,-24l0,-22.8l-10.921,0l0,-15.24l10.921,0l0,-17.76l19.2,0l0,17.76l17.759,0l0,15.24l-17.759,0l0,20.88c0,6.24 2.999,8.76 8.039,8.76c2.64,0 6.24,-0.96 8.76,-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#111111",
    d: "m559.855,140.96l-17.04,0l8.52,-18.24l22.8,0l-14.28,18.24zm22.2,37.92l0,4.92l-44.16,0c1.56,7.2 6.48,11.64 12.96,11.64c4.44,0 9.6,-1.08 12.84,-6.96l17.04,3.48c-5.16,12.72 -16.08,18.84 -29.88,18.84c-17.4,0 -31.8,-12.84 -31.8,-31.92c0,-18.96 14.4,-31.92 31.92,-31.92c17.04,0 30.72,12.24 31.08,31.92zm-31.08,-16.32c-5.4,0 -10.92,3.36 -12.72,9.48l24.84,0c-1.8,-6.48 -6.6,-9.48 -12.12,-9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#FACA15",
    d: "m458.453,131c0,-5.88 -4.68,-10.92 -11.16,-10.92c-6.48,0 -11.04,5.04 -11.04,10.92c0,6.12 4.56,10.68 11.04,10.68c6.48,0 11.16,-4.56 11.16,-10.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#E35019",
    d: "m309.274,131c0,-5.88 -4.68,-10.92 -11.16,-10.92c-6.48,0 -11.04,5.04 -11.04,10.92c0,6.12 4.56,10.68 11.04,10.68c6.48,0 11.16,-4.56 11.16,-10.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "#0BB3F0",
    d: "m472.282,11c0,-5.88001 -4.68,-10.92001 -11.16,-10.92001c-6.48,0 -11.04,5.04 -11.04,10.92001c0,6.12 4.56,10.68 11.04,10.68c6.48,0 11.16,-4.56 11.16,-10.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#FACA15",
    d: "m366.11,11c0,-5.88001 -4.68,-10.92001 -11.16,-10.92001c-6.48,0 -11.04,5.04 -11.04,10.92001c0,6.12 4.56,10.68 11.04,10.68c6.48,0 11.16,-4.56 11.16,-10.68z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrUnlimitedCreativity);
export default __webpack_public_path__ + "static/media/fr_unlimited-creativity.8b7e32c5893a698168e2717e534dec26.svg";
export { ForwardRef as ReactComponent };